import React, { useEffect, useState } from 'react'
import { MdClear } from "react-icons/md";
import { FaMagnifyingGlass } from 'react-icons/fa6'
import TextBox from 'devextreme-react/text-box'
import SelectBox from 'devextreme-react/select-box';
import useLoadingContractors from '../useLoadingContractors';

let cachedSalesTeams = []

const ContractorSearchSection = ({ filterCriteria, setFilterCriteria }) => {
  const { handleGetSalesTeams } = useLoadingContractors(null, null)
  const [salesTeams, setSalesTeams] = useState(cachedSalesTeams)

  useEffect(() => {
    getSalesTeams()
  }, [])

  const handleFilterChange = (fieldName, e) => {
    setFilterCriteria((prevCriteria) => ({
      ...prevCriteria,
      [fieldName]: e.value || ''
    }))
  }

  const getSalesTeams = async () => {
    if (cachedSalesTeams.length === 0) {
      const teams = await handleGetSalesTeams()
      setSalesTeams(teams)
      cachedSalesTeams = teams
    }
  }

  return (<>
    <div className="row contractor-page-filter-holder">
      <div className="col-auto">
        <FaMagnifyingGlass size={25} color='var(--primary)' />
      </div>
      <div className="col">
        <input className='contractor-searchBox-input' type='text'
          required={true}
          placeholder={'Szukaj'}
          value={filterCriteria.textSearch}
          onChange={(e) => { setFilterCriteria(prev => ({ ...prev, textSearch: e.target.value })) }}
        />
      </div>
      <div className="col-auto">
        <MdClear size={25} color='var(--primary)' cursor={'pointer'} onClick={() => setFilterCriteria(prev => ({ ...prev, textSearch: "" }))} />
      </div>
    </div>
    <div className="row mt-2">
      <div className="d-flex align-items-center">
        <div className='d-flex align-items-center me-3'>
          <SelectBox
            placeholder='Zespół handlowy'
            showClearButton={true}
            value={filterCriteria.salesTeam}
            onValueChanged={(e) => handleFilterChange('salesTeam', e)}
            noDataText='Brak danych'
            dataSource={salesTeams}
            searchEnabled={true}
            searchMode='contains'
          />
        </div>
        <div className='d-flex align-items-center me-3'>
          <TextBox
            placeholder='Miasto'
            showClearButton={true}
            value={filterCriteria.city}
            onValueChanged={(e) => handleFilterChange('city', e)}
          />
        </div>
        <div className='d-flex align-items-center'>
          <TextBox
            placeholder='Kod pocztowy'
            mask="99-999"
            showClearButton={true}
            value={filterCriteria.zipCode}
            onValueChanged={(e) => handleFilterChange('zipCode', e)}
          />
        </div>
      </div>
    </div>
  </>)
}

export default ContractorSearchSection